<template>
  <div class="voice_invite">
      <div class="room_num">
        <span>房间号：{{ roomnum }}</span>
      </div>
      
     <div class="bottom_bg">
     </div>
      <div class="bottom">
        <div class="logo">
          <img src="../assets/images/voiceinvite/logo.png" alt>
        </div>
        <div class="info">
          <p class="app">我是谜App</p>
          <p class="infos">不看脸的语聊交友社区</p>
        </div>
        <div class="btn_bg" @click="share" >
          加入房间
          <!-- <img src="../assets/images/voiceinvite/download.png" alt="" @click="share"> -->
        </div>
      </div>
        <!-- 引入模态组件 -->
    <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.'+ '点击右上角[...]'"
      :direct="'2. '+'选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
      :num="'房间号:'+roomnum"
    ></Appopen>
  </div>
</template>
<script>
import {appUrlAndroid,appUrlIOS} from "../assets/js/base64"
export default {
  name: "VoiceInvite",
  data() {
    return {
      roomnum:"",
      isAppopen:false
    };
  },
  components:{
     Appopen: () => import("../component/Appopen.vue")

  },
  created() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    this.roomType = this.$route.query.roomType;
    this.roomnum=this.$route.query.num;
    document.getElementsByTagName('title')[0].innerText= this.roomType == 2 ? '我是谜-包房' : '我是谜-语聊';
    if (this.roomType == 2) {
      this.privateroom = this.roomnum;//包房
    } else if(this.roomType == 1) {
      this.voiceroomnum = this.roomnum;//语聊
    }
  },
  mounted() {},
  methods: {
    share(){
        this.baseUrl='https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan';
         if(this.voiceroomnum){ 
           //语聊
           if (this.isAndroid) {
              window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid("310001","wsrn="+this.voiceroomnum)}`;
            } else if (this.isiOS) {
              let ua = navigator.userAgent.toLowerCase();
                if(ua.match(/QQ/i) == "qq"){
                  this.isAppopen = true
                }else{
                  window.location.href =appUrlIOS("310001","wsrn="+this.voiceroomnum);
                }
            }else{
             window.location.href = 'http://share.xiyacs.com/#/open'
           }
         }else if(this.privateroom){
           //包房
            if (this.isAndroid) {
              window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid("300001","wsprn="+this.privateroom)}`;
            } else if (this.isiOS) {
               let ua = navigator.userAgent.toLowerCase();
                if(ua.match(/QQ/i) == "qq"){
                  this.isAppopen = true
                }else{
                  window.location.href =appUrlIOS("300001",`wsprn=${this.privateroom}&wsrn=${this.privateroom}`);
                }
            }else{
             window.location.href = 'http://share.xiyacs.com/#/open'
           }
         }
    },
  
  },
  
};
</script>
<style scoped>
.voice_invite {
  background:url("../assets/images/voiceinvite/bg.png")no-repeat left top;
  width: 100%;
  height: 33.35rem;
  background-size: cover;
  position: relative;
}
.voice_invite .room_num {
  position: absolute;
  top: 0.6rem;
  left:50%;
  transform: translateX(-50%);
  display: block;
  width: 6rem;
  height: 1.5rem;
  background-color: #1e2e60;
  border-radius: 0.75rem;
  opacity: 0.4;
}
.voice_invite  span{
  display: inline-block;
  position: absolute;
  left:0.25rem;
  z-index:999;
  font-family: "NotoSansHans-Regular";
	font-size: 0.75rem;
	font-weight: normal;
	font-stretch: normal;
	line-height: 1.5rem;
	letter-spacing: 0rem;
	color: #ffffff;
  
}
.voice_invite .bottom_bg {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.5rem;
  background-color: #000000 ;
  opacity: 0.6
}
.voice_invite .bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.5rem;
}
.voice_invite .bottom .logo img {
  width: 100%;
  height: 100%;
}
.voice_invite .bottom .logo {
  position: absolute;
  width: 2.55rem;
  height: 2.55rem;
  top: 0.475rem;
  left: 0.75rem;
}
.voice_invite .bottom .info {
  padding-left: 3.85rem;
  padding-top: 0.7rem;
  padding-right: 5rem;
}
.voice_invite .bottom .info .app {
  font-family: "NotoSansHans-Bold";
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: white;
  text-align: left;
  z-index:9999;
}
.voice_invite .bottom .info .infos {
  font-family: " NotoSansHans-Regular";
  font-size: 0.75rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  text-align: left;
}
.voice_invite .bottom .btn_bg {
  position: absolute;
  top: 0.95rem;
  right: 0.75rem;
  width: 4.25rem;
  height: 1.6rem;
  background:linear-gradient(90deg,rgba(48,207,238,1) 0%,rgba(83,255,246,1) 100%);
  border-radius:0.475rem;
  font-size:0.75rem;
  font-family:"PingFangSC-Semibold,PingFang SC";
  font-weight:600;
  color:rgba(255,255,255,1);
  line-height:1.6rem;
  z-index:9999;
}
.bottom .btn_bg img {
  width: 100%;
  height: 100%;
}
/* motai */
.modial {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  height: 33.35rem;
  background-size: cover;
}
.modial .modial_in {
  padding-left:0.375rem;
  text-align: left;
  position: absolute;
  background:rgb(255, 255, 255);
  width: 8.75rem;
  height: 7rem;
  left: 50%;
  bottom: 50%;
  transform: translateX(-50%);
  border-radius: 0.5rem;
}
.modial .modial_in .title{
 font-weight: bold;
}
.modial .modial_in p {
  font-size: 0.75rem;
  margin-top: 0.5rem;
  color:black;
}
.modial .modial_in .room{
    font-size: 1rem;   
}

</style>





// WEBPACK FOOTER //
// src/Component/VoiceInvite.vue